// extracted by mini-css-extract-plugin
module.exports = {"CourseFAQ":"CourseFAQ_CourseFAQ__8_98a"};